import { z } from 'zod'

// Helper para transformar strings em números
const stringToNumber = (v) => (v === '' || v === null || v === undefined) ? null : Number(v)
const stringToInteger = (v) => (v === '' || v === null || v === undefined) ? null : parseInt(v, 10)

export const produtoSchema = z.object({
  // Identificação
  id_produto: z.preprocess(
    stringToInteger,
    z.number().int().nullable().optional()
  ),
  id_usuario: z.preprocess(
    stringToInteger,
    z.number().int().nullable().optional()
  ),
  cod_grupo: z.preprocess(
    stringToInteger,
    z.number().int().nullable().optional()
  ),
  codprod: z.preprocess(
    stringToInteger,
    z.number().int().nullable().optional()
  ),
  
  // Dados básicos
  ref_fornecedor: z.string().min(1, 'Referência do fornecedor é obrigatória'),
  produto: z.string().min(1, 'Nome do produto é obrigatório'),
  fornecedor: z.string().min(1, 'Fornecedor é obrigatório'),
  cod_inno: z.string().optional(),
  titulo_seo: z.string().optional(),
  
  // Estados de ativação
  ativo: z.enum(['S', 'N']).default('S'),
  ativo_site: z.enum(['S', 'N']).default('S'),
  prioridade: z.enum(['S', 'N']).optional().default('N'),
  
  // Links e recursos
  link_produto: z.string()
    .url('Link do produto deve ser uma URL válida')
    .optional()
    .or(z.literal(''))
    .nullable(),
  
  // Informações de estoque e pedido
  estoque: z.preprocess(
    stringToInteger,
    z.number().int().nonnegative('Estoque não pode ser negativo').default(0)
  ),
  qtd_min: z.preprocess(
    stringToInteger,
    z.number().int().nonnegative('Quantidade mínima não pode ser negativa').default(0)
  ),
  max_batidas: z.preprocess(
    stringToInteger,
    z.number().int().nonnegative().default(0).optional()
  ),
  prazo_min: z.preprocess(
    stringToInteger,
    z.number().int().nonnegative().default(0).optional()
  ),
  multiplo: z.preprocess(
    stringToInteger,
    z.number().int().nonnegative().default(0).optional()
  ),
  pedido_minimo: z.preprocess(
    stringToInteger,
    z.number().int().nonnegative().default(0).optional()
  ),
  
  // Custos e valores
  outros_custos: z.preprocess(
    stringToNumber,
    z.number().nonnegative('Custos não podem ser negativos').default(0).optional()
  ),
  
  // Impressão
  impressao: z.preprocess(
    stringToInteger,
    z.number().int().nonnegative().default(0).optional()
  ),
  tipo_impressao: z.preprocess(
    stringToInteger,
    z.number().int().nonnegative().default(0).optional()
  ),
  
  // Datas
  data_cadastro: z.string().optional().nullable(),
  data_foto: z.string().optional().nullable(),
  data_site: z.string().optional().nullable(),
  
  // Informações extras
  observacoes: z.string().optional().nullable(),
});

// Schemas específicos para cada aba
export const abaIdentificacaoSchema = produtoSchema.pick({ 
  id_produto: true,
  id_usuario: true,
  cod_grupo: true,
  codprod: true,
  titulo_seo: true,
});

export const abaBasicaSchema = produtoSchema.pick({ 
  ref_fornecedor: true, 
  produto: true, 
  fornecedor: true, 
  cod_inno: true
});

export const abaLinksSchema = produtoSchema.pick({
  link_produto: true
});

export const abaEstoqueSchema = produtoSchema.pick({
  estoque: true,
  qtd_min: true,
  multiplo: true,
  pedido_minimo: true,
  prioridade: true
});

export const abaProducaoSchema = produtoSchema.pick({
  max_batidas: true,
  prazo_min: true,
  impressao: true,
  tipo_impressao: true,
  outros_custos: true
});

export const abaConfiguracoesSchema = produtoSchema.pick({
  ativo: true,
  ativo_site: true
});

export const abaObservacoesSchema = produtoSchema.pick({
  observacoes: true
});
